import React from 'react'
import ManageOrganizations from '../../../components/AdminOrganizations/ManageOrganizations'

const OrganizationsPage = () => {
  return (
    <div className="w-full">
      <ManageOrganizations/>
    </div>
  )
}

export default OrganizationsPage
